<template>
  <div class="page-content">
    <div class="card row">
      <div class="card-body col-md-8">
        <div class="row d-flex justify-content-between align-items-center">
          <div class="col-7 col-sm-6">
            <form class="search-form" @submit.prevent="doSearch()">
              <div class="input-group border rounded-sm">
                <div class="input-group-prepend">
                  <div class="input-group-text border-0 rounded-sm">
                    <FeatherIcon type="search" class="icon-md cursor-pointer" />
                  </div>
                </div>
                <input v-model="search" type="text" class="form-control  border-0 rounded-sm" id="searchForm" placeholder="Search here...">
              </div>
            </form>
          </div>
          <div class="col-4 col-sm-3">
            <button class="btn btn-primary" @click="showModalGroup = true">Add Whatsapp Group</button>
          </div>
        </div>
        <p class="text-muted mt-3">Groups</p>
        <ul class="list-unstyled px-1">
          <li class="pr-1 mb-3" v-for="group in groupList" :key="group.id">
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center justify-content-between pb-1 flex-grow border-bottom">
                <div class="mr-2">
                  <p class="text-body font-weight-bold">{{ group.wappin_meta.group_data.name }}<b-badge class="p-1 ml-1" :variant="group.group_id ? 'success' : 'warning'">{{ group.group_id ? 'Approved' : 'Waiting' }}</b-badge></p>
                  <p class="text-body">{{ moreText(group.wappin_meta.group_data.description) }}</p>
                  <div class="d-flex align-items-center">
                    <p class="text-muted tx-13">{{ formatDate(group.created_at, "D MMM YYYY HH:mm") }}</p>
                  </div>
                </div>
                <div class="d-flex align-items-end">
                  <button @click="copyLink(group.link_group)" :disabled="group.link_group && group.group_id ? false : true" class="btn btn-outline-primary btn-sm mr-2">
                     Copy
                  </button>
                  <button @click="showModalListMemberGroup(group.id)" class="btn btn-outline-primary btn-sm mr-2">
                    <font-awesome icon="users"></font-awesome>
                  </button>
                  <button class="btn btn-outline-primary btn-sm" @click="showModalEditGroup = true; formEditGroup.id = group.id; formEditGroup.name = group.wappin_meta.group_data.name; formEditGroup.description = group.wappin_meta.group_data.description; formEditGroup.approval = group.wappin_meta.group_data.approval; formEditGroup.workspace_id = group.workspace_id;">
                    <font-awesome icon="edit"/>
                  </button> &nbsp;
                  <button :disabled="group.group_id ? false : true" class="btn btn-outline-primary btn-sm" @click="deleteGroup(group.id)">
                    <font-awesome icon="times"/>
                  </button>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <el-empty v-if="totalRow == 0" description="No data"></el-empty>
        <b-pagination v-if="totalRow > 10" v-model="currentPage" :total-rows="totalRow" :per-page="10"/>
      </div>
    </div>
    <b-modal v-model="showModalGroup" title="Add Whatsapp Group" hide-footer>
      <b-form @submit.prevent="createGroup" @reset="closeModalGroup">
        <b-form-group
          id="group-name-group"
          label="Group Name:"
          label-for="group-name">
          <b-form-input
            id="group-name"
            type="text"
            required
            v-model="formGroup.name" />
        </b-form-group>

        <b-form-group
          id="group-description-group"
          label="Group Description:"
          label-for="group-description">
          <b-form-input
            id="group-description"
            type="text"
            required
            v-model="formGroup.description" />
        </b-form-group>

        <b-form-group
          id="group-approval-group"
          label="Group Approval Usage:"
          label-for="group-approval">
            <b-form-checkbox id="group-approval" switch v-model="formGroup.approval">Used Approval</b-form-checkbox>
        </b-form-group>

        <b-form-group
          id="workspace-group"
          label="Workspace:"
          label-for="workspace">
          <b-form-select
            id="workspace"
            disabled
            :value="activeWorkspace._id"
            :options="workspaces"
            required />
        </b-form-group>

        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal v-model="showModalEditGroup" title="Edit Whatsapp Group" hide-footer>
      <b-form @submit.prevent="updateGroup" @reset="closeModalEditGroup">
        <b-form-group
          id="group-name-group"
          label="Group Name:"
          label-for="group-name">
          <b-form-input
            id="group-name"
            type="text"
            required
            v-model="formEditGroup.name" />
        </b-form-group>

        <b-form-group
          id="group-description-group"
          label="Group Description:"
          label-for="group-name">
          <b-form-input
            id="group-description"
            type="text"
            required
            v-model="formEditGroup.description" />
        </b-form-group>

        <b-form-group
          id="group-approval-group"
          label="Group Approval Usage:"
          label-for="group-approval">
            <b-form-checkbox switch disabled id="group-approval" v-model="formEditGroup.approval">Used Approval</b-form-checkbox>
        </b-form-group>

        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal v-model="showListMemberGroup" title="List Member Whatsapp Group" hide-footer>
      <div class="mt-2 table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone Number</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(member, idx_member) in groupList.find((v) => v.id === selectedConversationId)?.contacts || []" :key="idx_member">
            <td>{{ member?.name ? formatMemberName(member.name) : '-' }}</td>
            <td>{{ member?.phone_number ?? '-' }}</td>
          </tr>
          <el-empty v-if="member.count == 0" description="No data"></el-empty>
          <b-pagination v-if="member.count > member.per_page" v-model="memberPage" :total-rows="member.count" :per-page="member.per_page"/>
        </tbody>
      </table>
    </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import conversationsAPI from '../../../api/conversations';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  name: 'Whatsapp Groups',
  metaInfo: {
    title: 'Whatsapp Groups',
  },
  data() {
    return {
      loaderStack: 0,
      loader: null,
      userList: [],
      groupList: [],
      showModalGroup: false,
      showModalEditGroup: false,
      showListMemberGroup: false,
      search: '',
      page: 1,
      totalRow: 0,
      formGroup: {
        name: '',
        description: '',
        approval: false,
        workspace_id: '',
      },
      formEditGroup: {
        id: '',
        name: '',
        description: '',
        approval: false,
        workspace_id: '',
      },
      member: {
        rows: [],
        count: 0,
        page: 1,
        per_page: 10,
      },
      selectedConversationId: '',
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.page = val;
        this.getWhatsappGroup();
      },
    },
    memberPage: {
      get() {
        return this.mamber.page;
      },
      set(val) {
        this.member.page = val;
        this.showModalListMemberGroup();
      },
    },
    workspaces() {
      return this.$store.state.workspace.workspaces.map((workspace) => ({
        text: workspace.name,
        value: workspace._id,
      }));
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
  },
  mounted() {
    this.getWhatsappGroup();
  },
  methods: {
    copyLink(url) {
      navigator.clipboard.writeText(url).then(() => {
        this.$message({
          message: 'Copied',
          type: 'success',
        });
      }, (err) => {
        console.log(err);
      });
    },
    moreText(string) {
      return string && string.length > 100 ? `${string.substr(0, 90)}...` : string;
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    doSearch() {
      this.page = 1;
      this.getWhatsappGroup();
    },
    pageChanged(page) {
      this.page = page;
      this.getWhatsappGroup();
    },
    async getWhatsappGroup() {
      this.showLoader();
      await conversationsAPI.getWhatsappGroup({ workspace_id: this.activeWorkspace._id, page: this.page, search: this.search })
        .then((res) => {
          console.log('res==', res);
          this.totalRow = res.data.count;
          this.groupList = res.data.rows;
        })
        .catch(() => {});
      this.hideLoader();
    },
    clearForm() {
      // this.form = {
      //   user_id: '',
      //   workspace_id: '',
      // };
      this.formGroup = {
        name: '',
        description: '',
        approval: false,
        workspace_id: '',
      };
      this.formEditGroup = {
        id: '',
        name: '',
        description: '',
        approval: false,
        workspace_id: '',
      };
    },
    closeModalGroup() {
      this.showModalGroup = false;
      setTimeout(() => {
        this.clearForm();
      }, 500);
    },
    closeModalEditGroup() {
      this.showModalEditGroup = false;
      setTimeout(() => {
        this.clearForm();
      }, 500);
    },
    async showModalListMemberGroup(id) {
      this.showListMemberGroup = true;
      this.selectedConversationId = id;
      // this.showLoader();
      // await conversationsAPI.participantWhatsappGroup({ workspace_id: this.activeWorkspace._id, conversation_id: id })
      //   .then((res) => {
      //     console.log('res participant==', res.data);
      //     if (Object.values(res.data).length > 0) {
      //       this.member = {
      //         ...this.member,
      //         rows: res.data.rows,
      //         count: res.data.count,
      //       };
      //     }
      //   })
      //   .catch(() => {});
      // this.hideLoader();
      // setTimeout(() => {
      //   this.clearForm();
      // }, 500);
    },
    async createGroup() {
      this.showLoader();
      const { name, description, approval } = this.formGroup;
      this.formGroup.workspace_id = this.activeWorkspace._id;
      await conversationsAPI.createWhatsappGroup({
        workspace_id: this.activeWorkspace._id,
        group_name: name,
        group_description: description,
        group_approval: approval,
      })
        .then(async (response) => {
          await popupErrorMessages(response);
          this.$message({
            message: this.$t('whatsapp_groups.success.add'),
            type: 'success',
          });
          this.page = 1;
          this.search = '';
          this.getWhatsappGroup();
          this.closeModalGroup();
        })
        .catch(() => {});
      this.hideLoader();
    },
    async updateGroup() {
      this.showLoader();
      const {
        id, name, description,
      } = this.formEditGroup;
      await conversationsAPI.updateWhatsappGroup({
        workspace_id: this.activeWorkspace._id,
        conversation_id: id,
        group_name: name,
        group_description: description,
      })
        .then(async (response) => {
          await popupErrorMessages(response);
          this.$message({
            message: this.$t('whatsapp_groups.success.edit'),
            type: 'success',
          });
          this.page = 1;
          this.search = '';
          this.getWhatsappGroup();
          this.closeModalEditGroup();
        })
        .catch(() => {});
      this.hideLoader();
    },
    /* eslint-disable */
    async deleteGroup(id) {
      this.$confirm(this.$t('whatsapp_groups.confirm.delete'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const response = await conversationsAPI.deleteWhatsappGroup({
              workspace_id: this.activeWorkspace._id,
              conversation_id: id,
            })
            await popupErrorMessages(response);
            this.getWhatsappGroup();
            this.$message({
              message: this.$t('whatsapp_groups.success.delete'),
              type: 'success',
            });
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    formatDate(string, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(string).format(format);
    },
    handlerViewBtn(id) {
      this.$router.push({
        name: 'Groups - Members',
        params: {
          id,
        },
      });
    },
    formatMemberName(value) {
      if (value.startsWith('62') || value.startsWith('0') || value.startsWith('+')) {
        return '-';
      }
      return value;
    },
  },
};
</script>
